/* eslint-disable arrow-body-style */
// CardComponent.js
import React from "react";
import { EuiPanel, EuiButton, EuiFlexItem, EuiHorizontalRule, EuiTitle } from "@elastic/eui";
import { FormattedMessage, useIntl } from "react-intl";
import { TripFinancialsWrapper } from "../../reconciliation/style";

/**
 * Reusable Card Component with optional button functionality.
 *
 * Props:
 * - title: String - Title of the card.
 * - children: ReactNode - Content inside the card.
 * - showButton: Boolean - Show/hide the button.
 * - buttonText: String - Text on the button.
 * - onButtonClick: Function - Callback for button click.
 */
const SectionsCard = ({ title, children, showButton = false, onButtonClick, isButtonDisabled }) => {
    const intl = useIntl();
    return (
        <EuiPanel
            dir={intl.locale === "en" ? "ltr" : "rtl"}
            borderRadius="m"
            hasBorder
            paddingSize="none"
        >
            {/* Title and Optional Button in Same Line */}
            <TripFinancialsWrapper
                alignItems="center"
                justifyContent="spaceBetween"
            >
                <EuiFlexItem grow={false}>
                    {title && (
                        <EuiTitle size="xs">
                            <h3 style={{ color: "#198AA5" }}>{title}</h3>
                        </EuiTitle>
                    )}
                </EuiFlexItem>
                {showButton && (
                    <EuiFlexItem grow={false}>
                        <EuiButton
                            onClick={onButtonClick}
                            fill
                            color="primary"
                            size="m"
                            disabled={isButtonDisabled}
                            style={{ color: "white" }}
                        >
                            <FormattedMessage id="save" />
                        </EuiButton>
                    </EuiFlexItem>
                )}
            </TripFinancialsWrapper>
            <EuiHorizontalRule
                margin="none"
                size="full"
            />

            {/* Card Content */}
            <div style={{ padding: "16px" }}>{children}</div>
        </EuiPanel>
    );
};

export default SectionsCard;
